/* How it works page (sections/hw-landing.liquid): scroll reveal, sticky chapter nav (sits below the theme header, marks
   the current chapter), 7-step guide (tap, swipe, arrow keys), before/after slider, scroll timeline, body map with
   wear-time bars (phones: chips + result only), flip cards and the review rail arrows. Light: IntersectionObserver,
   CSS transforms, one rAF-throttled scroll handler. Without JS or with reduced motion everything stays readable and
   static. The explainer video runs via assets/cz-explainer.js. */
(function () {
  var sec = document.getElementById('hw');
  if (!sec || sec.__hw) return;
  sec.__hw = true;
  sec.classList.add('hw--js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
  var hasIO = 'IntersectionObserver' in window;
  var $ = function (s, r) { return (r || sec).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || sec).querySelectorAll(s)); };

  /* reveal on scroll – same classes as the Custom Studio landing (cz-landing.css) */
  if (!reduce && hasIO) {
    sec.classList.add('czl--anim', 'hw--anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.classList.add('is-in'); io.unobserve(el);
        setTimeout(function () { el.removeAttribute('data-czl-r'); el.classList.remove('is-in'); }, 1400);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-czl-r]').forEach(function (el) { io.observe(el); });
  }

  /* scroll-driven parts share one passive scroll listener */
  var scrollers = [];
  var ticking = false;
  function runScroll() { ticking = false; scrollers.forEach(function (f) { f(); }); }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* chapter nav: stick right below whatever part of the theme header is visible, highlight the current chapter */
  var nav = $('[data-hw-chapters]');
  if (nav) {
    var navIn = $('.hw-nav__in', nav), links = $$('a', nav), lastTop = -1, curCh = null;
    var chapters = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var headerBottom = function () {
      var b = 0;
      [].forEach.call(document.querySelectorAll('.shopify-section-group-header-group, .mobile-sticky-bar, header'), function (el) {
        if (sec.contains(el)) return;
        var cs = getComputedStyle(el);
        if ((cs.position !== 'sticky' && cs.position !== 'fixed') || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < 260 && r.bottom > b) b = r.bottom;
      });
      return Math.max(0, Math.min(Math.round(b), 300));
    };
    /* the theme header hides while scrolling down and comes back when scrolling up: remember both heights */
    var minTop = null, maxTop = 0;
    var place = function () {
      var t = headerBottom();
      if (t > maxTop) maxTop = t;
      if (window.pageYOffset > 400 && (minTop === null || t < minTop)) minTop = t;
      if (t !== lastTop) { lastTop = t; sec.style.setProperty('--hw-navtop', t + 'px'); }
    };
    var mark = function () {
      var nb = nav.getBoundingClientRect().bottom, line = nb + (window.innerHeight - nb) * 0.35, on = null;
      chapters.forEach(function (c, i) { if (c && c.getBoundingClientRect().top < line) on = i; });
      if (on === curCh) return;
      curCh = on;
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === on); if (i === on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      var a = links[on];
      if (a && navIn.scrollWidth > navIn.clientWidth) {
        var x = a.offsetLeft - (navIn.clientWidth - a.offsetWidth) / 2;
        navIn.scrollLeft = Math.max(0, x);
      }
    };
    var settle;
    window.addEventListener('load', place);
    scrollers.push(function () {
      place(); mark();
      /* the theme header slides in/out with a transition: measure again once it has settled */
      clearTimeout(settle); settle = setTimeout(function () { place(); mark(); }, 360);
    });
    /* jump links: land the chapter heading just below the nav, whether the header shows or not */
    $$('a[href^="#hw-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var c = document.getElementById(a.getAttribute('href').slice(1)); if (!c) return;
        e.preventDefault();
        var navH = nav.getBoundingClientRect().height;
        var down = c.getBoundingClientRect().top > nav.getBoundingClientRect().bottom;
        /* going down the header slides away, going up it comes back; a generous first guess, then fine-tune downwards only
           (scrolling back up would bring the header in again) */
        var top = down ? (minTop === null ? Math.max(lastTop, 130) : minTop) : Math.max(maxTop, lastTop);
        var y = c.getBoundingClientRect().top + window.pageYOffset - navH - top - (down ? 20 : 32);
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
        /* once the scroll has come to rest and the header has settled, close a too-big gap */
        var lastY = -1, still = 0, tries = 0;
        var check = setInterval(function () {
          var yy = window.pageYOffset;
          still = yy === lastY ? still + 1 : 0; lastY = yy;
          if (still < 4 && ++tries < 40) return;
          clearInterval(check); place();
          var gap = c.getBoundingClientRect().top - nav.getBoundingClientRect().bottom;
          if (gap > 40) window.scrollBy(0, gap - 20);
          /* going up the header is already back, so nudging up is safe */
          else if (!down && gap < 14) window.scrollBy(0, gap - 28);
        }, 100);
      });
    });
  }

  /* 2 · steps: icon tabs, back / next, swipe, arrow keys */
  var st = $('[data-hw-steps]');
  if (st) {
    var panels = $$('.hw-st__panel', st), tabs = $$('[role="tab"]', st);
    var prev = $('[data-hw-st="-1"]', st), next = $('[data-hw-st="1"]', st), n = panels.length, at = 0;
    var go = function (i, focusTab) {
      at = (i + n) % n;
      panels.forEach(function (p, j) { p.classList.toggle('is-on', j === at); });
      tabs.forEach(function (t, j) { var on = j === at; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; t.classList.toggle('is-past', j < at); });
      prev.disabled = at === 0;
      next.textContent = at === n - 1 ? next.getAttribute('data-again') : next.getAttribute('data-next');
      if (focusTab && tabs[at]) tabs[at].focus();
    };
    prev.addEventListener('click', function () { go(at - 1); });
    next.addEventListener('click', function () { go(at === n - 1 ? 0 : at + 1); });
    tabs.forEach(function (t, j) {
      t.addEventListener('click', function () { go(j); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); go(at + 1, true); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); go(0, true); }
        else if (e.key === 'End') { e.preventDefault(); go(n - 1, true); }
      });
    });
    var sw = $('[data-hw-swipe]', st), x0 = null, y0 = 0;
    sw.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; });
    sw.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(at + (dx < 0 ? 1 : -1));
    });
    sw.addEventListener('pointercancel', function () { x0 = null; });
    go(0);
  }

  /* 3 · before / after: native range input (touch, mouse, keyboard) drives --x; a short hint swing when it appears */
  var ba = $('[data-hw-ba]');
  if (ba) {
    var range = $('.hw-ba__range', ba);
    var setX = function (v) { ba.style.setProperty('--x', v + '%'); };
    range.addEventListener('input', function () { ba.__touched = true; setX(range.value); });
    /* pointer drag on the whole image (the range stays for keyboard and screen readers) */
    var drag = false;
    var moveTo = function (e) {
      var r = ba.getBoundingClientRect(), v = Math.round((e.clientX - r.left) / r.width * 1000) / 10;
      v = Math.max(0, Math.min(100, v)); range.value = Math.round(v); setX(v);
    };
    ba.addEventListener('pointerdown', function (e) {
      drag = true; ba.__touched = true; ba.classList.add('is-drag'); moveTo(e);
      if (ba.setPointerCapture) try { ba.setPointerCapture(e.pointerId); } catch (er) {}
    });
    ba.addEventListener('pointermove', function (e) { if (drag) moveTo(e); });
    var end = function () { drag = false; ba.classList.remove('is-drag'); };
    ba.addEventListener('pointerup', end); ba.addEventListener('pointercancel', end);
    if (!reduce && hasIO) {
      var hinted = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || hinted || ba.__touched) return;
          hinted = true;
          var t0 = performance.now(), dur = 1800;
          (function swing(now) {
            if (ba.__touched) return;
            var t = Math.min(1, (now - t0) / dur), v = 50 + Math.sin(t * Math.PI * 2) * 22 * (1 - t);
            range.value = Math.round(v); setX(v.toFixed(1));
            if (t < 1) requestAnimationFrame(swing);
          })(t0);
        });
      }, { threshold: 0.6 }).observe(ba);
    }
  }

  /* 3 · timeline: active stop at the viewport centre, lime line fills with the scroll position */
  var tl = $('[data-hw-tl]');
  if (tl) {
    var items = $$('.hw-tl__item', tl), imgs = $$('.hw-tl__stage .hw-tl__img', tl), chip = $('[data-hw-tl-chip]', tl);
    var line = $('.hw-tl__line', tl), track = $('.hw-tl__track', tl), cur = -1;
    var setTl = function (i) {
      if (i === cur) return; cur = i;
      items.forEach(function (it, j) { it.classList.toggle('is-on', j === i); it.classList.toggle('is-past', j < i); });
      imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
      if (chip && items[i]) chip.textContent = items[i].getAttribute('data-k');
    };
    scrollers.push(function () {
      var mid = window.innerHeight * 0.5, best = 0;
      items.forEach(function (it, j) { if (it.getBoundingClientRect().top < mid) best = j; });
      setTl(best);
      var r = track.getBoundingClientRect();
      var p = (mid - r.top) / Math.max(1, r.height * 0.82);
      line.style.setProperty('--tl', Math.max(0, Math.min(1, p)).toFixed(3));
    });
  }

  /* 3b · timeline stop 3: hero montage video, in the desktop stage and in the phone item. Poster first; the mp4 is set
     only when its box is displayed and on screen (stage: only while stop 3 is on), paused otherwise. Phones 360 px
     (540 px with devicePixelRatio >= 2), desktop 720 px. Never with reduced motion or data saver: the poster stays. */
  var saveData = navigator.connection && navigator.connection.saveData;
  var tlVids = $$('[data-hw-tlvid]').map(function (box) { return { box: box, v: box.querySelector('video'), seen: false }; })
    .filter(function (s) { return s.v; });
  if (tlVids.length && hasIO && !reduce && !saveData) {
    var vidSrc = function (v) {
      if (window.innerWidth >= 900) return v.getAttribute('data-src-hd');
      return (window.devicePixelRatio || 1) >= 2 ? v.getAttribute('data-src-md') : v.getAttribute('data-src-sd');
    };
    var vidSync = function () {
      tlVids.forEach(function (s) {
        var on = s.seen && s.box.getClientRects().length > 0 && (!s.box.classList.contains('hw-tl__img') || s.box.classList.contains('is-on'));
        if (on) {
          if (!s.v.getAttribute('src')) s.v.src = vidSrc(s.v);
          if (s.v.paused) { var pr = s.v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else if (!s.v.paused) s.v.pause();
      });
    };
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { tlVids.forEach(function (s) { if (s.box === e.target) s.seen = e.isIntersecting; }); });
      vidSync();
    }, { rootMargin: '150px 0px' });
    tlVids.forEach(function (s) {
      s.v.addEventListener('playing', function () { s.box.classList.add('is-play'); });
      vio.observe(s.box);
    });
    scrollers.push(vidSync);
  }

  /* 4 · body map: tap a zone (figure, chip or row) → detail bars. Desktop: "all" shows every area and a second tap
     goes back to it. Phones (no figure): one area is always selected, so the chips and the result belong together. */
  var map = $('[data-hw-map]');
  if (map) {
    var firstZone = (function () { var b = $('.hw-map__chips button:not([data-z="all"])', map); return b ? b.getAttribute('data-z') : 'all'; })();
    var sel = function (z) {
      map.setAttribute('data-sel', z);
      $$('.hw-z', map).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-z') === z); });
      $$('.hw-map__chips button', map).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-z') === z); });
      $$('.hw-map__row', map).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-z') === z); });
      $$('.hw-map__d', map).forEach(function (d) {
        var on = d.getAttribute('data-z') === z;
        d.hidden = !on; d.classList.remove('is-on');
        if (on) { void d.offsetWidth; d.classList.add('is-on'); }
      });
    };
    map.addEventListener('click', function (e) {
      var t = e.target.closest('[data-z]');
      if (!t || !map.contains(t) || t.classList.contains('hw-map__d') || t.classList.contains('hw-map__row')) return;
      var z = t.getAttribute('data-z');
      if (phone.matches) { sel(z); return; }
      sel(z === map.getAttribute('data-sel') && z !== 'all' ? 'all' : z);
    });
    var fit = function () {
      var s = map.getAttribute('data-sel');
      if (phone.matches && (!s || s === 'all')) sel(firstZone);
      else if (!s) sel('all');
    };
    fit();
    if (phone.addEventListener) phone.addEventListener('change', fit);
    if (hasIO && !reduce) {
      new IntersectionObserver(function (es, o) {
        es.forEach(function (e) { if (e.isIntersecting) { map.classList.add('is-in'); o.disconnect(); } });
      }, { threshold: 0.25 }).observe(map);
    } else map.classList.add('is-in');
  }

  /* 6 · flip cards */
  $$('.hw-flip').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); });
  });

  /* rail arrows at the left / right edge of the rail, vertically centred on the photos (same as .plpb-nav on
     home / collection), one card per click, hidden at the start / end (W12) */
  function railArrows(nav, rail, reduce) {
    var wrap = nav.parentNode, prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]'), raf = 0;
    var update = function () {
      raf = 0;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      nav.hidden = max <= 0;
      var m = rail.querySelector('.czl-rev__img, .czl-reel__media') || rail.querySelector('li');
      if (m) { var mb = m.getBoundingClientRect(), wb = wrap.getBoundingClientRect(); if (mb.height) wrap.style.setProperty('--czl-arrow-y', Math.round(mb.top - wb.top + mb.height / 2) + 'px'); }
    };
    var soon = function () { if (!raf) raf = requestAnimationFrame(update); };
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]'); if (!btn) return;
      var item = rail.querySelector('li'), gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      var stepW = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      rail.scrollBy({ left: Number(btn.getAttribute('data-dir')) * stepW, behavior: reduce ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    if ('ResizeObserver' in window) new ResizeObserver(soon).observe(rail);
    update();
  }
  $$('[data-hw-nav]').forEach(function (nv) {
    var rail = $('[data-hw-rail="' + nv.getAttribute('data-hw-nav') + '"]');
    if (!rail) { nv.hidden = true; return; }
    railArrows(nv, rail, reduce);
  });


  /* Custom Studio explainer dialog: opens, starts the video (same click = sound allowed), pauses on close */
  document.querySelectorAll("[data-hw-vid-open]").forEach(function (btn) {
    var dlg = btn.closest(".hw-tool") && btn.closest(".hw-tool").querySelector("[data-hw-vid]");
    if (!dlg || typeof dlg.showModal !== "function") return;
    btn.addEventListener("click", function () {
      dlg.showModal();
      var play = dlg.querySelector("[data-czx-play]");
      if (play) play.click(); else { var v = dlg.querySelector("video"); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    });
    dlg.querySelector("[data-hw-vid-close]").addEventListener("click", function () { dlg.close(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener("close", function () { dlg.querySelectorAll("video").forEach(function (v) { v.pause(); }); });
  });


  /* «Wie geht das?» on the two design tiles: the short guide in a dialog (X, Escape or a tap outside closes it) */
  document.querySelectorAll("[data-hw-how-open]").forEach(function (btn) {
    var dlg = btn.closest(".hw-tool") && btn.closest(".hw-tool").querySelector("[data-hw-how]");
    if (!dlg || typeof dlg.showModal !== "function") return;
    btn.addEventListener("click", function () { dlg.showModal(); });
    dlg.querySelector("[data-hw-how-close]").addEventListener("click", function () { dlg.close(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
  });

  runScroll();
})();
